import { uri } from '../data-util'
import langs from './language.json'
import { html, render } from 'lit/html.js'

// ----------------------------------------------
// Snippet for Overview
// ----------------------------------------------
export { provider } from './provider'

export function title( lang ) {
  return langs[ lang ][ "title" ]
}
export { text } from './text'

export { questions } from './questions'